export enum GaugeModes {
  DirectTransmission = 'Direct Transmission',
  Backscatter = 'Backscatter',
}

export enum MaximumDensityFrom {
  None = 'None',
  ClientProvided = 'Client Provided',
  MixDesign = 'Mix Design',
}
